import { useEffect } from 'react';
import { get } from 'lodash';

const TICKET_ASSIGNMENT_FORM_VALIDATE_EVENT = 'assignment_form:validate';

const useTicketCompleteValidator = workflowQueueAssignment => {
  useEffect(() => {
    if (workflowQueueAssignment) {
      const assignmentForm = window.$('#assignment_form');

      const validateWorkflowQueueAssignment = (event, triggeringButton) => {
        const mandatoryFieldNamesToText = {
          ticketType: 'Ticket Type',
          clinicalDesignation: 'Clinical Designation',
          category: 'Category',
          disposition: 'Disposition',
        };

        const missingFields = Object.keys(mandatoryFieldNamesToText).filter(
          field => !get(workflowQueueAssignment, [field, 'code'])
        );

        if (missingFields.length > 0) {
          const assignmentFormDiv = document.getElementById('assignment_form');
          assignmentFormDiv.scrollIntoView({ behavior: 'smooth' });

          const missingFieldsText = missingFields.map(field => mandatoryFieldNamesToText[field]).join(', ');
          window.alert(`You must assign ${missingFieldsText} to the ticket`);
        } else {
          window.$(`#${triggeringButton}`).trigger(`${triggeringButton}:submission_unblocked`);
        }
      };

      assignmentForm.on(TICKET_ASSIGNMENT_FORM_VALIDATE_EVENT, validateWorkflowQueueAssignment);

      return () => assignmentForm.off(TICKET_ASSIGNMENT_FORM_VALIDATE_EVENT, validateWorkflowQueueAssignment);
    }
  }, [workflowQueueAssignment]);
};

export default useTicketCompleteValidator;
